<template>
  <div>
    <div v-if='toggledGroup.group' class="items-center quick-animations-types flex-none flex-row flex overflow-x-auto my-2">
      <timeline-clock-outline class='text-white mr-1' :size='32' />
      <span v-show='false' class="text-sm text-gray-300 font-light mr-2">Select</span>
      <button :class="quicktweenClasses(quickTween)"
              class="quick-animation-button"
              v-for='quickTween in toggledGroup.quickTweens'
              :key='quickTween.name'
              @click='toggleQuicktween(quickTween)' >

        {{quickTween.label}}
      </button>
    </div>

    <div class="flex flex-row overflow-x-auto quick-animations-groups">
      <button v-if='!!component.__animator'
              class='quick-animation-group outline-button'
              :class='isNone ? "animation-group-used" : ""'
              @click='toggleQuicktween({type:"none"})' >
        None
      </button>


      <div v-show='!!component.__animator'
          v-for='group in groupedQuickTweens'
          :key='group.group'
          class="flex-none mr-1">

        <button :class='quicktweenGroupClasses(group)'
                @click='toggleGroup(group)'>{{group.group}}</button>

      </div>
    </div>


  </div>
</template>
<script>
import TimelineClockOutline from '@icons/TimelineClockOutline.vue';
import allAvailableQuicktweens from '@edit/tree/quicktweens.js';
import { types, createComponent } from '@edit/tree/componentsdb.js';
import Treeutil from '@edit/tree/treeutil.js';
import { intersection, toPairs, groupBy, cloneDeep } from 'lodash';
export default {
  props:{
    transform: {
      type: Object,
      required: true
    },
    component: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    transformsAndSource:{
      type: Object,
      required:true
    }
  },
  mounted() {
    this.$ana.track({
      eventCategory:'ui',
      eventAction:'showQuickAnimate'
    });
  },
  components:{
    TimelineClockOutline
  },
  data() {

    const availableQuicktweens = allAvailableQuicktweens.filter( (qt) => {
      if (!this.component.tags) {
        return true;
      } else {
        return intersection(this.component.tags, qt.tags).length;
      }
    });

    const groupedQuickTweens = toPairs(groupBy(availableQuicktweens, 'group')).map( ([group,quickTweens]) => {
      return {
        group,
        quickTweens
      }
    });

    const treeutil = new Treeutil(this.transformsAndSource.from);

    //const component = this.getComponent(treeutil);

    const quickSchema = types.tween.quickSchema;

    const firstGroupWithSelectedTween = groupedQuickTweens.filter( (group) => {
      return group.quickTweens.filter( (tween) => {
        return this.isSelected(tween)
      }).length > 0;
    });
    console.log('BLAAAAAAA', firstGroupWithSelectedTween);

    let toggledGroup = {};
    if (firstGroupWithSelectedTween.length) {
      toggledGroup = firstGroupWithSelectedTween[0];
    }


    return {
      quicktweens: [],
      availableQuicktweens,
      groupedQuickTweens,
      //component,
      treeutil,
      quickSchema,
      toggledGroup
    }
  },
  methods: {
    toggleGroup(group) {
      if (this.toggledGroup.group !== group.group) {
        this.toggledGroup = group;
      } else {
        this.toggledGroup = {};
      }
    },
    getComponent(treeutil) {
      const component = this.partutil.findComponentForTransform(this.transform);
      const {fromComponents,toComponents} = treeutil.getFromAndToForComponent(component);

      const hasTween = fromComponents.map( ({component}) => {
        return component;
      }).filter( ({type}) => {
        return type === 'tween';
      });

      if (!hasTween.length) {
        let tweenComponent = createComponent('tween');
        const {addedComponents,addedLinks} = treeutil.addComponentWithLinkData(
          component,
          {name:'link'},
          tweenComponent);
        tweenComponent = addedComponents[0];
        return tweenComponent;
      } else {
        return hasTween[0];
      }
    },
    isSelected(quickTween) {
      return this.component.tweens.find( (tween) => {
        return tween.name === quickTween.name;
      });
    },
    quicktweenGroupClasses(group) {

      const isGroupSelected = this.toggledGroup.group === group.group; //? "outline-button-selected" : "outline-button"'
      const groupHasSelectedTween = group.quickTweens.filter( (tween) => {
        return this.isSelected(tween)
      }).length > 0;
      return isGroupSelected ? "quick-animation-group outline-button-selected" : (groupHasSelectedTween ? "outline-button animation-group-used quick-animation-group" : "outline-button quick-animation-group")
    },
    quicktweenClasses(quickTween) {
//bg-green-500 
      const classes = [];
      classes.push('quick-animation-type');
      if (this.isSelected(quickTween) || (quickTween.type === "none" && this.component.tweens.length === 0)) {
        classes.push("quick-animation-button-selected");
      } else {
        classes.push("quick-animation-button");
      }
      return classes;
    },
    toggleQuicktween(quickTween) {

      const ov = cloneDeep(this.component);
      if (quickTween.type === 'none') {
        this.component.tweens = [];
        this.$emit('change', {
          ov,
          nv:this.component
        });
        this.toggledGroup = {}
        return;
      }
      if (!this.isSelected(quickTween)) {
        // find other tweens with same group, and disable them
        this.component.tweens = this.component.tweens.filter( (tween) => {
          const tweenGroup = this.availableQuicktweens.find( (qt) => {
            return qt.name === tween.name;
          });
          if (tweenGroup) {
            return tweenGroup.group !== quickTween.group;
          } else {
            return false;
          }
        });

        this.component.tweens.push(quickTween);
        this.$ana.track({
          eventCategory:'ui',
          eventAction:'toggleQuickTween',
          extra:{name:quickTween.name,toggledOn:true}
        });
        this.$emit('change', {
          ov,
          nv:this.component
        });


      } else {
        this.component.tweens = this.component.tweens.filter( (tween) => {
          return tween.name !== quickTween.name;
        });
        this.$ana.track({
          eventCategory:'ui',
          eventAction:'toggleQuickTween',
          extra:{name:quickTween.name,toggledOn:false}
        });

        this.$emit('change', {
          ov,
          nv:this.component
        });
      }
    }
  },
  computed: {
    isNone() {
      return this.component.tweens.length === 0;
    }
  },
}
</script>
<style>
.quick-animations-groups {
  @apply flex flex-row;
}
.quick-animations-types {
  @apply flex flex-row;
}
.quick-animations-types .quick-animation-type {
  @apply mr-1 h-8 flex-none text-sm font-semibold rounded truncate;
}
.quick-animation-type:focus {
  @apply outline-none;
}
.quick-animation-group {
  @apply w-16 h-6 text-xs flex-none;
}
</style>
